export const h = {
  navMenu: ["INÍCIO","PRÉ-REGISTRO", "HEROIS", "CARACTERÍSTICAS"],

  }


// WEBPACK FOOTER //
// ./src/i18n/lan/pt.js